import { Navigate } from 'react-router-dom';
import authService from '../services/auth.service';

/**
 * GuestRoute Component
 * Chỉ cho phép user chưa login mới truy cập được (login, register pages)
 * Nếu đã login, redirect về trang chính
 */
const GuestRoute = ({ children }) => {
  const isLoggedIn = authService.isLoggedIn();

  if (isLoggedIn) {
    // Redirect to main page if already logged in
    return <Navigate to="/breakout-tool" replace />;
  }

  // Render children if not logged in
  return children;
};

export default GuestRoute;

